'use strict';

/*global BasicQueue*/
/*global services*/

function CompletionQueue(containerId) {
  BasicQueue.call(this, containerId);

  this.init();
}

CompletionQueue.prototype = $.extend({}, BasicQueue.prototype, {
  constructor: 'CompletionQueue',

  registerCallbacks: function registerCallbacks() {
    var _this = this;

    return _this;
  },

  //----------------------------------------------------------------------------

  processItem: function processItem($item) {
    var _this = this;

    services.get('completion-service').runCompletion({ joiningSymbol: $item.data('joining_symbol'), handlingUnit: $item.data('handling_unit') });

    return _this;
  },

  //----------------------------------------------------------------------------

  init: function init() {
    var _this = this;

    _this.registerCallbacks();

    return _this;
  }
});
